import {Close} from '@mui/icons-material';
import {Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import {i18n} from 'src/i18n';
import ActivoService from 'src/modules/activo/activoService';
import Errors from 'src/modules/shared/error/errors';
import ActivoForm from 'src/view/activo/form/ActivoForm';
import ActivoFormFieldConfig from 'src/view/activo/form/ActivoFormFieldConfig';

function ActivoFormModal(props) {
  const [saveLoading, setSaveLoading] = useState(false);

  const doSubmit = async (_, data) => {
    try {
      setSaveLoading(true);
      const {id} = await ActivoService.create(data);
      const record = await ActivoService.find(id);
      props.onSuccess(record);
    } catch (error) {
      Errors.handle(error);
    } finally {
      setSaveLoading(false);
    }
  };

  const doClose = () => {
    return props.onClose();
  };

  return ReactDOM.createPortal(
    <Dialog open={true} onClose={doClose} maxWidth="md" fullWidth={true}>
      <DialogTitle style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <h2 style={{margin: 0}}>{i18n('entities.activo.new.title')}</h2>
        <IconButton onClick={doClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {props.fieldConfig ? (
          <ActivoFormFieldConfig saveLoading={saveLoading} onSubmit={doSubmit} onCancel={doClose} modal />
        ) : (
          <ActivoForm saveLoading={saveLoading} onSubmit={doSubmit} onCancel={doClose} modal />
        )}
      </DialogContent>
    </Dialog>,
    (document as any).getElementById('modal-root'),
  );
}

export default ActivoFormModal;
